import React from 'react';
import PropTypes from 'prop-types';

import { i18n as I18n } from '../../../utils/i18n';

const InstructionalFormActions = ({
  isValid,
  showBackBtn,
  submitBtnText,
  backBtnText,
  handleBackBtnClick,
  handleCancleBtnClick,
  showCancelBtn,
  cancelBtnText,
}) => (
  <p className="instructional-form__actions">
    <input
      className="button button--secondary button--block"
      type="submit"
      disabled={!isValid}
      value={submitBtnText}
      data-cy="continueButton"
      data-testid="instructionalFormSubmitButton"
    />
    {showBackBtn && (
      <button
        onClick={handleBackBtnClick}
        className="button button--text"
        data-testid="goBack"
      >
        {backBtnText}
      </button>
    )}
    {showCancelBtn && (
      <button
        onClick={handleCancleBtnClick}
        className="button button--text"
        data-testid="cancel"
      >
        {cancelBtnText}
      </button>
    )}
  </p>
);

InstructionalFormActions.propTypes = {
  isValid: PropTypes.bool,
  showBackBtn: PropTypes.bool,
  submitBtnText: PropTypes.string,
  backBtnText: PropTypes.string,
  handleBackBtnClick: PropTypes.func,
  handleCancleBtnClick: PropTypes.func,
  showCancelBtn: PropTypes.bool,
  cancelBtnText: PropTypes.string,
};

InstructionalFormActions.defaultProps = {
  isValid: false,
  showBackBtn: true,
  submitBtnText: I18n.t('continue'),
  backBtnText: I18n.t('go_back'),
  handleBackBtnClick: null,
  handleCancleBtnClick: null,
  showCancelBtn: false,
  cancelBtnText: I18n.t('shared.cancel'),
};

export default InstructionalFormActions;
